module.exports = __webpack_public_path__ + "img/settings.2221b765.svg";